import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;
let assignedLocations = JSON.parse(localStorage.getItem("assingedL"));
const locations = assignedLocations?.map((e) => {
  return '"' + e.value + '"';
});

/**
 *
 * @param {FetchListParams} params
 * @returns {Promise<FetchSmartProposalResponse>}
 */
export function requestSmartProposal(params) {
  /**
   * @NOTE This limit is hard code for now because we need to implement the sorting nad filterting only at front end.
   *  In future we may remove it when sorting and filterting is implemented on backend
   */
  return params === undefined
    ? fetch.get(
        `${BASE_URL}/api/app/smart-proposal?${params}&location[in]=[${locations}]`,
        {
          params: {
            limit: 10000,
          },
        }
      )
    : fetch.get(
        `${BASE_URL}/api/app/smart-proposal?${params}`
      );
}

/**
 *
 * @param {smartProposal} data
 */
export function requestCreateSmartProposal(data) {
  return fetch.post(`${BASE_URL}/api/app/smart-proposal`, {
    ...data,
  });
}

/**
 *
 * @param {smartProposal} data
 */
export function requestUpdateSmartProposal(value) {
  const data = { ...value };
  delete data["_id"];
  return fetch.put(`${BASE_URL}/api/app/smart-proposal/${data.id}`, {
    ...data,
  });
}

/**
 * @param {smartProposal} data
 */
export function requestDeleteSmartProposal(value) {
  const data = { ...data };
  throw Error("Not implemented");
}

/**
 * @param {smartProposal} data
 */
export function requestForArchive(value) {
  return fetch.patch(`${BASE_URL}/api/app/smart-proposal/toggleArchive`, {
    ...value,
  });
}

/**
 * @param {smartProposal} data
 */
export function requestForDelete(value) {
  return fetch.patch(`${BASE_URL}/api/app/smart-proposal/toggleDelete`, {
    ...value,
  });
}

/**
 * @param {smartProposal} data
 */
export function requestForBookMark(value) {
  return fetch.patch(`${BASE_URL}/api/app/smart-proposal/toggleBookmark`, {
    ...value,
  });
}

/**
 * smart suite agreement
 * @param {smartProposal} data
 */
export function requestProposalActivity(params) {
  return fetch.get(`${BASE_URL}/api/app/smart-proposal/proposalactivity`, {
    params: { limit: params },
  });
}

/**
 * @param {sendDraftProposal} data
 */
export function requestCreateSendDraftProposal(data) {
  return fetch.post(`${BASE_URL}/api/app/smart-proposal/draftProposal`, {
    ...data,
  });
}

/**
 * @param {smartProposal} data
 */
export function requestForAddNotes(value) {
  return fetch.patch(`${BASE_URL}/api/app/smart-proposal/addNotes`, {
    ...value,
  });
}

/**
 * @param {smartProposal} data
 */
export function requestForUpdateProposal(data) {
  return fetch.post(`${BASE_URL}/api/app/smart-proposal/changePropDetails`, {
    ...data,
  });
}

/**
 * @param {smartProposal} data
 */
export function requsetForContactList(value) {
  return fetch.get(`${BASE_URL}/api/app/client-spoc`, {
    params: { limit: 10000 },
  });
}
export function requsetForContactList1(value) {
  return fetch.get(`${BASE_URL}/api/app/client-spoc/new`, {
    params: { limit: 10000 },
  });
}

export function requestProposalKPIS(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/smart-proposal/getKpi/proposal`, {
      params: { limit: 100 },
    });
  } else {
    return fetch.get(
      `${BASE_URL}/api/app/smart-proposal/getKpi/proposal?${params}`,
      {
        params: { limit: 100 },
      }
    );
  }
}
// upload smart proposal document
export function requestForUploadDocumentForProposal(body) {
  return fetch.patch(
    `${BASE_URL}/api/app/smart-proposal/uploadFile/${body.id}`,
    {
      ...body,
    }
  );
}

// for public url
export function requestForPublicUrl(body) {
  return fetch.patch(`${BASE_URL}/api/app/smart-proposal/generatePublicLink`, {
    ...body,
  });
}

export function requestSmartProposalReport(params) {
  if (params === undefined) {
    return fetch.post(
      `${BASE_URL}/api/app/smart-proposal/smart-proposal-report?limit=3000`
    );
  } else {
    return fetch.post(
      `${BASE_URL}/api/app/smart-proposal/smart-proposal-report?limit=3000&${params}`
    );
  }
}

export function requestSmartProposalReportKpis(param) {
  if (param === undefined) {
    return fetch.get(
      `${BASE_URL}/api/app/smart-proposal/getKpi/smart-proposal?limit=1000`
    );
  } else {
    return fetch.get(
      `${BASE_URL}/api/app/smart-proposal/getKpi/smart-proposal?${param}`
    );
  }
}

/**
 * remove document
 * @returns
 */
export function requestRemoveDocument(body) {
  return fetch.patch(
    `${BASE_URL}/api/app/smart-proposal/deleteFile/${body.id}`,
    {
      ...body,
    }
  );
}

/**
 * download proposal service
 * @returns
 */
export function requestForProposalDownload(body) {
    return fetch.post(`${BASE_URL}/api/app/template/generate-pdf`, {
      ...body,
    });
}
export async function requestForProposalDoc(value, type) {
  return fetch.get(
    `${BASE_URL}/api/app/proposal-document/getDocumentsByLocation?location=${value}&type=${type}`
  );
}
